import { NavBarModelConfig } from "./models/nav-bar.model.config";

import { Privileges } from "../../shared/constants/privileges";
import { Roles } from "../../shared/constants/roles";

export const navMenuLinks: NavBarModelConfig[] = [
    {
        menuId: 'member',
        menuLabel: 'Member',
        menuLink: '',
        hasSubMenu: true,
        isActive: true,
        adminToolsHeading: 'ADMIN TOOLS',
        accessIds: [Roles.SUPER_ADMIN, Privileges.MEMBERS, Privileges.MEMBER_RESTRICT, Privileges.MANAGE_SHIFTED_MEMBERS],
        customerAssistanceTools: [
            {
                subMenuId: 'searchMemberAccount',
                subMenuLabel: 'Search Member Account',
                subMenuLink: '/member/search-member-account',
                linkType: 'route',
                openInNewTab: false,
                hasAccess: false,
                accessIds: [Roles.SUPER_ADMIN, Privileges.MEMBERS]
            },
            {
                subMenuId: 'manageEobDeliveryRestrictions',
                subMenuLabel: 'Manage EOB Delivery Restrictions',
                subMenuLink: '/member/manage-eob-delivery-restrictions',
                linkType: 'route',
                openInNewTab: false,
                hasAccess: false,
                accessIds: [Roles.SUPER_ADMIN, Privileges.MEMBERS]
            },
            {
                subMenuId: 'manageBillingDeliveryPreferences',
                subMenuLabel: 'Manage Billing Delivery Preferences',
                subMenuLink: '/member/manage-billing-delivery-preferences',
                linkType: 'route',
                openInNewTab: false,
                hasAccess: false,
                accessIds: [Roles.SUPER_ADMIN, Privileges.MEMBERS]
            },
            {
                subMenuId: 'makeAPayment',
                subMenuLabel: 'Make a Payment',
                subMenuLink: '/member/make-a-payment',
                linkType: 'route',
                openInNewTab: false,
                hasAccess: false,
                accessIds: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.REPRESENTATIVE, Roles.USER_MANAGER]
            },
            {
                subMenuId: 'memberPaymentResearch',
                subMenuLabel: 'Member Payment Research',
                subMenuLink: '/sso-redirection',
                linkType: 'route',
                openInNewTab: true,
                hasAccess: false,
                accessIds: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.REPRESENTATIVE, Roles.USER_MANAGER],
                ssoType: 'MemberPaymentResearch',
            },
            {
                subMenuId: 'hicnMbiLookup',
                subMenuLabel: 'HICN MBI Lookup',
                subMenuLink: '/member/hicn-mbi-lookup',
                linkType: 'route',
                openInNewTab: false,
                hasAccess: false,
                accessIds: [Roles.SUPER_ADMIN, Privileges.MEMBER_HICNMBI]
            },
            {
                subMenuId: 'ccm',
                subMenuLabel: 'CCM',
                subMenuLink: '/ccm',
                linkType: 'route',
                openInNewTab: false,
                hasAccess: false,
                accessIds: [Roles.SUPER_ADMIN, Privileges.CCM_MEMBER, Privileges.CCM_PROSPECT, Privileges.CCM_PROVIDER, Privileges.CCM_PRODUCER, Privileges.CCM_EMPLOYER]
            }
        ],
        adminTools: [
            {
                subMenuId: 'ifpProductData',
                subMenuLabel: 'IFP Product Data Upload',
                subMenuLink: '/member/ifp-product-data',
                linkType: 'route',
                openInNewTab: false,
                hasAccess: true,
                accessIds: [Roles.SUPER_ADMIN]
            }
        ]
    },
    {
        menuId: 'provider',
        menuLabel: 'Provider',
        menuLink: '',
        hasSubMenu: true,
        isActive: true,
        adminToolsHeading: 'ADMIN TOOLS',
        accessIds: [Roles.SUPER_ADMIN, Privileges.PROVIDERS, Privileges.PROVIDER_REPORTS],
        customerAssistanceTools: [
            {
                subMenuId: 'searchProviderAccount',
                subMenuLabel: 'Search Provider Account',
                subMenuLink: '/provider/search-provider-account',
                linkType: 'route',
                openInNewTab: false,
                hasAccess: false,
                accessIds: [Roles.SUPER_ADMIN, Privileges.PROVIDERS]
            },
            {
                subMenuId: 'searchProviderRecord',
                subMenuLabel: 'Search Provider Record',
                subMenuLink: '/provider/search-provider-record',
                linkType: 'route',
                openInNewTab: false,
                hasAccess: false,
                accessIds: [Roles.SUPER_ADMIN, Privileges.PROVIDERS]
            }
        ],
        adminTools: [
            {
                subMenuId: 'providerReports',
                subMenuLabel: 'Provider Reports',
                subMenuLink: '/provider/provider-reports',
                linkType: 'route',
                openInNewTab: false,
                hasAccess: false,
                accessIds: [Roles.SUPER_ADMIN, Privileges.PROVIDER_REPORTS]
            }
        ]
    },
    {
        menuId: 'employer',
        menuLabel: 'Employer',
        menuLink: '',
        hasSubMenu: true,
        isActive: true,
        adminToolsHeading: 'ADMIN TOOLS',
        accessIds: [Roles.SUPER_ADMIN, Privileges.EMPLOYERS, Privileges.CWS_BUS, Privileges.CWS_TECH, Privileges.EMPLOYER_SURVEY_REPORT],
        customerAssistanceTools: [
            {
                subMenuId: 'searchEmployerUser',
                subMenuLabel: 'Search Employer User',
                subMenuLink: '/employer/search-employer-user',
                linkType: 'route',
                openInNewTab: false,
                hasAccess: false,
                accessIds: [Roles.SUPER_ADMIN, Privileges.EMPLOYERS]
            },
            {
                subMenuId: 'searchEmployerGroups',
                subMenuLabel: 'Search Employer Groups',
                subMenuLink: '/employer/search-employer-groups',
                linkType: 'route',
                openInNewTab: false,
                hasAccess: false,
                accessIds: [Roles.SUPER_ADMIN, Privileges.EMPLOYERS]
            },
            {
                subMenuId: 'exceptionList',
                subMenuLabel: 'Exception List',
                subMenuLink: '/employer/exception-list',
                linkType: 'route',
                openInNewTab: false,
                hasAccess: false,
                accessIds: [Roles.SUPER_ADMIN, Privileges.EMPLOYERS]
            },
            {
                subMenuId: 'registrationReport',
                subMenuLabel: 'Registration Report',
                subMenuLink: '/employer/registration-report',
                linkType: 'route',
                openInNewTab: false,
                hasAccess: false,
                accessIds: [Roles.SUPER_ADMIN, Privileges.EMPLOYERS]
            },
            {
                subMenuId: 'paymentReport',
                subMenuLabel: 'Payment Report',
                subMenuLink: '/employer/payment-report',
                linkType: 'route',
                openInNewTab: false,
                hasAccess: false,
                accessIds: [Roles.SUPER_ADMIN, Privileges.EMPL_BILLING_ACCESS]
            },
            {
                subMenuId: 'healthcareSpendingReport',
                subMenuLabel: 'Prescription Drug and Healthcare Spending Report',
                subMenuLink: '/employer/healthcare-spending-report',
                linkType: 'route',
                openInNewTab: false,
                hasAccess: false,
                accessIds: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.REPRESENTATIVE, Privileges.EMPLOYER_SURVEY_REPORT]
            },
            {
                subMenuId: 'medicalLossRatioReport',
                subMenuLabel: 'Medical Loss Ratio Report',
                subMenuLink: '/employer/medical-loss-ratio-report',
                linkType: 'route',
                openInNewTab: false,
                hasAccess: false,
                accessIds: [Privileges.EMPLOYER_MLR_REPORT]
            }
        ],
        adminTools: [
            {
                subMenuId: 'createExternalReportingAdmin',
                subMenuLabel: 'Create External Reporting Admin',
                subMenuLink: '/employer/create-reporting-admin',
                linkType: 'route',
                openInNewTab: false,
                hasAccess: false,
                accessIds: [Roles.ADMIN, Roles.REPRESENTATIVE, Roles.SUPER_ADMIN, Privileges.REPORTADMIN_IN_BSC]
            },
            {
                subMenuId: 'whyzenEmployerReporting',
                subMenuLabel: 'Whyzen Employer Reporting',
                subMenuLink: 'callWhyzenSso',
                linkType: 'method',
                openInNewTab: false,
                hasAccess: false,
                accessIds: [Roles.ADMIN, Roles.REPRESENTATIVE, Roles.SUPER_ADMIN]
            }
        ]
    },
    {
        menuId: 'selfFunded',
        menuLabel: 'Self-Funded Portal',
        menuLink: '',
        hasSubMenu: true,
        isActive: true,
        adminToolsHeading: null,
        accessIds: [Roles.SUPER_ADMIN, Privileges.TPA_CREATEUSER, Privileges.TPA_SEARCH, Privileges.TPA_EXTERNAL_NOTIFICATIONS, Privileges.TPA_USER_DASHBOARD],
        customerAssistanceTools: [
            {
                subMenuId: 'searchUser',
                subMenuLabel: 'Search User',
                subMenuLink: '/self-funded/search-user',
                linkType: 'route',
                openInNewTab: false,
                hasAccess: false,
                accessIds: [Privileges.TPA_SEARCH]
            },
            {
                subMenuId: 'createOrModifyUser',
                subMenuLabel: 'Create/Modify User',
                subMenuLink: '/self-funded/create-user',
                linkType: 'route',
                openInNewTab: false,
                hasAccess: false,
                accessIds: [Privileges.TPA_CREATEUSER]
            },
            {
                subMenuId: 'registerEmailDomain',
                subMenuLabel: 'Register Email Domain',
                subMenuLink: '/self-funded/email-domains',
                linkType: 'route',
                openInNewTab: false,
                hasAccess: false,
                accessIds: [Privileges.TPA_CREATEUSER]
            },
            {
                subMenuId: 'externalNotifications',
                subMenuLabel: 'External Notifications',
                subMenuLink: '/self-funded/create-notification',
                linkType: 'route',
                openInNewTab: false,
                hasAccess: false,
                accessIds: [Privileges.TPA_EXTERNAL_NOTIFICATIONS]
            },
            {
                subMenuId: 'userDashboard',
                subMenuLabel: 'User Dashboard',
                subMenuLink: '/self-funded/user-dashboard',
                linkType: 'route',
                openInNewTab: false,
                hasAccess: false,
                accessIds: [Privileges.TPA_USER_DASHBOARD]
            }
        ],
        adminTools: []
    },
    {
        menuId: 'producer',
        menuLabel: 'Producer',
        menuLink: '',
        hasSubMenu: true,
        isActive: true,
        adminToolsHeading: 'ADMIN TOOLS',
        accessIds: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.REPRESENTATIVE],
        customerAssistanceTools: [
            {
                subMenuId: 'manageProducerUser',
                subMenuLabel: 'Manage Producer User',
                subMenuLink: '/producer/manage-producer-user',
                linkType: 'route',
                openInNewTab: false,
                hasAccess: false,
                accessIds: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.REPRESENTATIVE, Privileges.PRODUCER_SEARCH_PRODUCER]
            },
            {
                subMenuId: 'brokerConnection',
                subMenuLabel: 'Broker Connection',
                subMenuLink: '/sso-redirection',
                linkType: 'route',
                openInNewTab: true,
                hasAccess: false,
                accessIds: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.REPRESENTATIVE, Privileges.PRODUCER_DIRECT_SALES_AGENT],
                ssoType: 'broker',
            },
            {
                subMenuId: 'brokerConnection',
                subMenuLabel: 'Broker Connection',
                subMenuLink: '/sso-redirection',
                linkType: 'route',
                openInNewTab: true,
                hasAccess: false,
                accessIds: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.REPRESENTATIVE, Privileges.PRODUCER_ADMIN],
                ssoType: 'broker',
            }
        ],
        adminTools: [
            {
                subMenuId: 'createNewBrokerAnalyst',
                subMenuLabel: 'Create New Broker Analyst',
                subMenuLink: '/producer/create-broker-analyst',
                linkType: 'route',
                openInNewTab: false,
                hasAccess: false,
                accessIds: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.REPRESENTATIVE, Privileges.PRODUCER_NEW_BROKER_ANALYST]
            },
            {
                subMenuId: 'generateBrokerReports',
                subMenuLabel: 'Generate Broker reports',
                subMenuLink: '/producer/generate-broker-reports',
                linkType: 'route',
                openInNewTab: false,
                hasAccess: false,
                accessIds: [Roles.SUPER_ADMIN, Roles.ADMIN, Privileges.PRODUCER_GENERATE_BROKER_REPORTS]
            }
        ]
    },
    {
        menuId: 'prospect',
        menuLabel: 'Prospect',
        menuLink: '',
        hasSubMenu: true,
        isActive: true,
        adminToolsHeading: 'ADMIN TOOLS',
        accessIds: [Roles.SUPER_ADMIN, Privileges.SEARCH_PROSPECT],
        customerAssistanceTools: [
            {
                subMenuId: 'zipariPlansAndEnroll',
                subMenuLabel: 'Zipari plans & Enroll',
                subMenuLink: '/sso-redirection',
                linkType: 'route',
                openInNewTab: true,
                hasAccess: false,
                accessIds: [Roles.SUPER_ADMIN, Privileges.SEARCH_PROSPECT],
                ssoType: 'zipari',
            },
            {
                subMenuId: 'ifpEnrollments',
                subMenuLabel: 'IFP enrollments',
                subMenuLink: '/sso-redirection',
                linkType: 'route',
                openInNewTab: true,
                hasAccess: false,
                accessIds: [Roles.SUPER_ADMIN, Privileges.SEARCH_PROSPECT],
                ssoType: 'broker',
            },
            {
                subMenuId: 'userAccountActivation',
                subMenuLabel: 'User Account Activation',
                subMenuLink: '/prospect/user-account-activation',
                linkType: 'route',
                openInNewTab: true,
                hasAccess: false,
                accessIds: [Roles.SUPER_ADMIN, Privileges.SEARCH_PROSPECT]
            }
        ],
        adminTools: [
            {
                subMenuId: 'openAdminTool',
                subMenuLabel: 'Open Admin Tool',
                subMenuLink: '/sso-redirection', // Check if it's an SSO or page
                linkType: 'route',
                openInNewTab: true,
                hasAccess: false,
                accessIds: [Roles.SUPER_ADMIN, Privileges.OPEN_ADMIN_TOOL],
                ssoType: 'openAdminTool',
            }
        ]
    },
    {
        menuId: 'benefits',
        menuLabel: 'Benefits',
        menuLink: '',
        hasSubMenu: true,
        isActive: true,
        adminToolsHeading: null,
        accessIds: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.REPRESENTATIVE, Privileges.CUSTOM, Privileges.CUSTOM_ADD],
        customerAssistanceTools: [
            {
                subMenuId: 'benefitLookup',
                subMenuLabel: 'Benefit Lookup',
                subMenuLink: '/benefits/benefit-lookup',
                linkType: 'route',
                openInNewTab: false,
                hasAccess: false,
                accessIds: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.REPRESENTATIVE]
            }
        ],
        adminTools: []
    },
    {
        menuId: 'manageCsaUsers',
        menuLabel: 'Manage CSA Users',
        menuLink: '',
        hasSubMenu: true,
        adminToolsHeading: 'ADMIN TOOLS',
        isActive: true,
        accessIds: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.USER_MANAGER],
        customerAssistanceTools: [
            {
                subMenuId: 'myProfile',
                subMenuLabel: 'My Profile',
                subMenuLink: '/my-profile',
                linkType: 'route',
                openInNewTab: false,
                hasAccess: false,
                accessIds: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.REPRESENTATIVE, Roles.USER_MANAGER]
            },
            {
                subMenuId: 'createOrModifyCsaUsers',
                subMenuLabel: 'Create/Modify CSA Users',
                subMenuLink: '/manage-csa-users/search-user',
                linkType: 'route',
                openInNewTab: false,
                hasAccess: false,
                accessIds: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.USER_MANAGER]
            }
        ],
        adminTools: [
            {
                subMenuId: 'csaUserReport',
                subMenuLabel: 'CSA User Report',
                subMenuLink: '/manage-csa-users/reports',
                linkType: 'route',
                openInNewTab: false,
                hasAccess: false,
                accessIds: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.USER_MANAGER]
            },
            {
                subMenuId: 'providerActivityReport',
                subMenuLabel: 'Provider Activity Report',
                subMenuLink: 'callProviderActivitySplunk',
                linkType: 'method',
                openInNewTab: true,
                hasAccess: false,
                accessIds: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.USER_MANAGER]
            },
            {
                subMenuId: 'employerActivityReport',
                subMenuLabel: 'Employer Activity Report',
                subMenuLink: 'callEmployerActivitySplunk',
                linkType: 'method',
                openInNewTab: false,
                hasAccess: false,
                accessIds: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.USER_MANAGER]
            },
            {
                subMenuId: 'memberActivityReport',
                subMenuLabel: 'Member Activity Report',
                subMenuLink: 'callMemberActivitySplunk',
                linkType: 'method',
                openInNewTab: false,
                hasAccess: false,
                accessIds: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.USER_MANAGER]
            },
            {
                subMenuId: 'prospectActivityReport',
                subMenuLabel: 'Prospect Activity Report',
                subMenuLink: 'callProspectActivitySplunk',
                linkType: 'method',
                openInNewTab: false,
                hasAccess: false,
                accessIds: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.USER_MANAGER]
            }

        ]
    },
    {
        menuId: 'manageOem',
        menuLabel: 'Manage OEP',
        menuLink: '/manage-oep',
        hasSubMenu: false,
        isActive: true,
        adminToolsHeading: null,
        accessIds: [Roles.SUPER_ADMIN],
        customerAssistanceTools: [],
        adminTools: []
    },
    {
        menuId: 'ccm',
        menuLabel: 'CCM',
        menuLink: '/ccm',
        hasSubMenu: false,
        isActive: true,
        adminToolsHeading: null,
        accessIds: [Roles.SUPER_ADMIN, Privileges.CCM_MEMBER, Privileges.CCM_PROSPECT, Privileges.CCM_PROVIDER, Privileges.CCM_PRODUCER, Privileges.CCM_EMPLOYER],
        customerAssistanceTools: [],
        adminTools: []
    }
]